import { Component } from '@angular/core';
import { AbstractDynamicFormControl } from '../../abstact-dynamic-form-control.directive';
import { DynamicFormControlDirective } from '../../dynamic-form-control.directive';

@Component({
  selector: 'dynamic-form-callout-text',
  templateUrl: 'callout-text.component.html',
  providers: [
    {
      provide: DynamicFormControlDirective,
      useExisting: CalloutTextComponent,
    },
  ],
})
export class CalloutTextComponent extends AbstractDynamicFormControl {}
